// extracted by mini-css-extract-plugin
export default {"container":"all-page_container__1z6G1","menuLabel":"all-page_menuLabel__lKYtu","filters":"all-page_filters__2xdrh"};